
import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";

const EmojiSkeleton = memo(({ count = 12 }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="border rounded-lg p-3 flex flex-col items-center justify-center shadow gap-3"
        >
          <Skeleton
            variant="rounded"
            width={64}
            height={64}
            animation="wave"
            sx={{ borderRadius: "50%" }}
          />

          <Skeleton
            variant="rounded"
            width={80}
            height={16}
            animation="wave"
          />
        </div>
      ))}
    </div>
  );
});

EmojiSkeleton.displayName = "EmojiSkeleton";

export default EmojiSkeleton;
